import { schema } from 'normalizr';
import labelSchema from './label';

const fileGroupSchema = new schema.Entity('fileGroups', {
  targets: [labelSchema],
});

export default fileGroupSchema;
